module.exports = __webpack_public_path__ + "img/logo.a9c2916b.png";